import { render, staticRenderFns } from "./shimmer-component.vue?vue&type=template&id=ce3cc00e&"
import script from "./shimmer-component.vue?vue&type=script&lang=js&"
export * from "./shimmer-component.vue?vue&type=script&lang=js&"
import style0 from "./shimmer-component.vue?vue&type=style&index=0&id=ce3cc00e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports